import SxDef from '@core/types/SxDef';

const useSx = (): SxDef => ({
  root: { '.pdf-previewer-container': { display: 'flex', justifyContent: 'center' } },
});

export default useSx;
